/*
 * https://gist.github.com/devongovett/1381839
 * Minimal classList shim for IE 9
 * By Devon Govett
 * MIT LICENSE
 */
// Fixed for SVG elements
if (!("classList" in document.documentElement) && Object.defineProperty && typeof Element !== "undefined") {
	Object.defineProperty(Element.prototype, 'classList', {
		get: function() {
			var self = this;
			function getClassName(){
				return typeof SVGAnimatedString !== "undefined" && self.className instanceof SVGAnimatedString ? self.className.animVal : self.className;
			}
			function setClassName(value){
				if(typeof SVGAnimatedString !== "undefined" && self.className instanceof SVGAnimatedString){
					self.className.baseVal = value;
				}else{
					self.className = value;
				}
			}
			function update(fn) {
				return function(value) {
					var classes = getClassName().split(/\s+/),
						index = classes.indexOf(value);

					fn(classes, index, value);
					setClassName(classes.join(" "));
				}
			}

			var ret = {
				add: update(function(classes, index, value) {
					~index || classes.push(value);
				}),

				remove: update(function(classes, index) {
					~index && classes.splice(index, 1);
				}),

				toggle: update(function(classes, index, value) {
					~index ? classes.splice(index, 1) : classes.push(value);
				}),

				contains: function(value) {
					return !!~getClassName().split(/\s+/).indexOf(value);
				},

				item: function(i) {
					return getClassName().split(/\s+/)[i] || null;
				}
			};
			Object.defineProperty(ret, 'length', {
				get: function() {
					return getClassName().split(/\s+/).length;
				}
			});

			return ret;
		}
	});
}